export default "__VITE_ASSET__IB3DUFl2__"